export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.83736 38.8692C9.07581 37.2954 10.0681 35.9374 11.495 35.232L20.0571 30.999L24.8068 34.7745L29.5566 30.999L38.1187 35.232C39.5456 35.9374 40.5378 37.2954 40.7763 38.8692L41.3175 42.4411C41.4733 43.4697 40.677 44.3958 39.6367 44.3958H9.97698C8.93664 44.3958 8.14031 43.4697 8.29616 42.4411L8.83736 38.8692Z"
      fill="#8FB4FF"
    />
    <rect x="17.7432" y="12" width="14.1275" height="17.7811" rx="7.06373" fill="#8FB4FF" />
    <path
      d="M50.4434 37.2061L59.0049 41.4395L59.375 41.6367C61.1883 42.6752 62.4385 44.4883 62.7539 46.5693L63.2949 50.1416L63.3203 50.3506C63.525 52.5042 61.8302 54.3955 59.6367 54.3955H29.9766C27.7126 54.3953 25.9793 52.3801 26.3184 50.1416L26.8604 46.5693L26.9355 46.1572C27.3738 44.1141 28.7216 42.3724 30.6084 41.4395L39.1709 37.2061L40.3086 36.6436L41.3018 37.4336L44.8066 40.2197L48.3125 37.4336L49.3057 36.6436L50.4434 37.2061Z"
      fill="#8FB4FF"
      stroke="white"
      strokeWidth="4"
    />
    <rect x="37.7432" y="20" width="14.1275" height="17.7811" rx="7.06373" fill="#8FB4FF" />
  </svg>
)
